exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".sandwichMenu__sandwich___F0ycR {\n  margin-left: 1rem;\n  font-size: 1.5rem;\n  color: #6b6767;\n  cursor: pointer;\n  position: relative; }\n  .sandwichMenu__sandwich___F0ycR ul {\n    position: absolute;\n    background: #FFFFFF;\n    list-style-type: none;\n    padding: 0;\n    margin: 0;\n    left: 0;\n    font-size: 1rem;\n    width: auto;\n    white-space: nowrap;\n    box-shadow: 0px 0px 10px #c3c3c3;\n    z-index: 89;\n    top: 30px; }\n    .sandwichMenu__sandwich___F0ycR ul li {\n      padding: 6px; }\n      .sandwichMenu__sandwich___F0ycR ul li:hover {\n        background: #D9D9D9; }\n  .sandwichMenu__sandwich___F0ycR.sandwichMenu__toTheLeft___IHIYW ul {\n    left: auto;\n    right: 0; }\n", ""]);

// exports
exports.locals = {
	"sandwich": "sandwichMenu__sandwich___F0ycR",
	"toTheLeft": "sandwichMenu__toTheLeft___IHIYW"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?modules=true&importLoaders=1&localIdentName=[name]__[local]___[hash:base64:5]!./~/sass-loader?includePaths[]=./src/styles!./src/components/SandwichMenu/sandwichMenu.scss
// module id = 736
// module chunks = 0